import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";

export default class extends Controller {
  connect() {
    const swiperContainer = this.element.querySelector(".mySwiper");
    
    if (swiperContainer) {
      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
      });

      const btnNext = this.element.querySelectorAll("#btn-next");
      const btnPrev = this.element.querySelectorAll("#btn-prev");
      
      btnNext.forEach((btn) => {
        btn.addEventListener("click", () => {
          this.swiper.slideNext();
        });
      });
      
      btnPrev.forEach((btn) => {
        btn.addEventListener("click", () => {
          this.swiper.slidePrev();
        });
      });
    }
  }
}